import SignalRActionTypes from './signalR-types'

export const startFetchTransactions = data => ({
    type: SignalRActionTypes.START_FETCH_TRANSACTIONS,
    payload: data,
})
